import { HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { AuthService } from '../../../auth/service/auth.service';
import { inject, Injectable } from '@angular/core';
import { auth } from '../../../../constent/routes';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
}) export class tokenInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const auth: AuthService = inject(AuthService);
    const token = auth.getToken();

    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      return next.handle(req);
    }
    return next.handle(req);
  }

}
